import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import maharashtraMap from '../../assets/images/map/map1.png';
import { useSelector } from 'react-redux';

const Excavations = () => {
    const navigate = useNavigate();
    const selectedLang = useSelector((state) => state.language.selectedLang);

    const content = {
        English: {
            title: 'Exploration & Excavation',
            breadcrumb: {
                home: 'HOME',
                page: 'EXPLORATIONS & EXCAVATIONS'
            },
            divisionLabel: 'Division',
            divisions: [
                { id: 1, name: 'Ratnagiri', count: 3, path: "ratnagiri" },
                { id: 2, name: 'Nashik', count: 2, path: "nashik" },
                { id: 3, name: 'Pune', count: 1, path: "pune" },
                { id: 4, name: 'Chhatrapati Sambhajinagar', count: 3, path: "chhatrapatisambhajinagar" },
                { id: 5, name: 'Nanded', count: 2, path: "nanded" },
                { id: 6, name: 'Nagpur', count: 13, path: "nagpur" },
            ],
        },
        मराठी: {
            title: 'अन्वेषण आणि उत्खनन',
            breadcrumb: {
                home: 'मुख्यपृष्ठ ',
                page: 'अन्वेषण आणि उत्खनन'
            },
            divisionLabel: 'विभाग',
            divisions: [
                { id: 1, name: 'रत्नागिरी', count: "३", path: "ratnagiri" },
                { id: 2, name: 'नाशिक', count: "२", path: "nashik" },
                { id: 3, name: 'पुणे', count: "१", path: "pune"  },
                { id: 4, name: 'छत्रपती संभाजी नगर', count: "३", path: "chhatrapatisambhajinagar" },
                { id: 5, name: 'नांदेड', count: "२", path: "nanded"  },
                { id: 6, name: 'नागपूर', count: "१३", path: "nagpur" },
            ],
        },
    };

    const t = content[selectedLang];


    const handleDivisionClick = (path) => {
        if (path) {
            navigate(`/excavations/${path}`);
        }
    };

    return (
        <div className="bg-[#F6F6EC] min-h-screen px-4 py-16">
            {/* Heading */}
            <div className="text-center mb-8">
                <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
                    {t.title}
                </h1>
                <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
                    <span style={{ color: "#DD9827" }}>
                        <Link to="/" className="hover:underline">
                            {t.breadcrumb.home}
                        </Link>{" "}/{" "}</span>
                    {t.breadcrumb.page}
                </p>
            </div>

            {/* Content */}
            <div className="px-4 md:px-10 max-w-7xl mx-auto mt-20">
                <div className="flex flex-col md:flex-row gap-8 items-start">
                    {/* Sidebar */}
                    <div className="bg-[#F6F6EC] rounded-2xl border-[1px] border-[#F8D6BF] p-4 md:w-1/4 w-full">
                        <h2 className="text-left ml-2 text-[14px] sm:text-lg md:text-xl lg:text-[26px] font-semibold pb-2">
                            {t.divisionLabel}
                        </h2>
                        <ul className="space-y-1 no-dark-bg">
                            {t.divisions.map((item) => (
                                <li key={item.id}>
                                    <button
                                        type="button"
                                        className="w-full text-left flex justify-between items-center text-gray-800 bg-[#EFEDE0] px-3 py-2 rounded-md cursor-pointer hover:bg-[#FB9C00] hover:text-white transition font-futura"
                                        onClick={() => handleDivisionClick(item.path)}
                                        disabled={!item.path}
                                    >
                                        <span>{item.name}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>


                    </div>

                    {/* Map Area */}
                    <div className="flex-1 flex justify-center">
                        <img
                            src={maharashtraMap}
                            alt="Maharashtra Map"
                            className="w-full max-w-2xl h-auto object-contain rounded-md"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Excavations;
